<template>
    <div v-cloak class="configuration-wrapper">
        <div class="configuration-title">
            <p>Universal Settings</p>
            <button class="btn btn-light" v-if="isAllowedToEdit && !isEditable" v-on:click="toggleEditable">edit</button>
        </div>
        <ul class="configuration-list">
            <li v-for="configuration in globalConfigurations" :key="configuration.id">
                <p class="configuration-holder">
                    {{ configuration.configuration_type.name }}
                    <span v-if="!isEditable && configuration.configuration_type.type === 'boolean'"  class="configruation-span">{{ configuration.value === '1' ? "Yes" : "No" }}</span>
                    <toggle-switch v-if="isEditable  && configuration.configuration_type.type === 'boolean'" v-on:input="updateVueModel($event, configuration)" v-bind:id="configuration.id" v-bind:name="configuration.name" v-bind:value="configuration.value === '1' ? true : false"></toggle-switch>

                    <span v-if="!isEditable && configuration.configuration_type.type === 'integer'"  class="configruation-span">{{ configuration.value }}</span>
                    <input type="number" v-if="isEditable  && configuration.configuration_type.type === 'integer'" v-model="configuration.value">
                </p>
            </li>
        </ul>
        <button class="btn btn-light" v-if="isAllowedToEdit && isEditable" v-on:click="saveConfigurations">Save</button>
        <button class="btn btn-danger" v-if="isAllowedToEdit && isEditable" v-on:click="cancel">Cancel</button>
    </div>
</template>

<script>
import Configurations from "../Services/Configurations";

export default {
        name: "GlobablConfigurationComponent",
        props: {
            isAllowedToEdit: Boolean,
        },
        data: function()  {
            return {
                globalConfigurations: [],
                isEditable: false,
            }
        },
        mounted() {
            this.getGlobalConfigurations();
        },
        methods: {
            getGlobalConfigurations:  function() {
                Configurations.getGlobalConfigurations().then((configurations) => {
                    this.globalConfigurations = configurations;
                });
            },

            setGlobalConfiguration: function(configuration) {
                Configurations.setGlobalConfiguration(configuration).then((configurations) => {
                    // this.globalConfigurations = configurations;
                    this.$forceUpdate();
                }).catch((error) => {
                    this.getGlobalConfigurations();
                    console.log(error.response);
                })
            },

            updateVueModel: function($event, configuration) {
                configuration.value = $event ? '1' : '0';
                this.$forceUpdate();
            },

            cancel: function() {
              this.isEditable = false;
              this.getGlobalConfigurations();
            },

            saveConfigurations: function() {

                let confirmation = false;

                confirmation = confirm("These settings will be applied for all centres in ACA.\n" +
                    "\n" +
                    "Are you sure you want to continue?");

                if (!confirmation) {
                    return false;
                }

                this.globalConfigurations.forEach((configuration) => {
                   this.setGlobalConfiguration(configuration);
                });

                this.isEditable = false;
            },

            toggleEditable: function() {
                this.isEditable = !this.isEditable;
            }
        }
    }
</script>

<style scoped>
    .configuration-holder {
        height: 28px;
        line-height: 28px;
    }
    .ui-toggle-switch {
        float: left;
        width: 60px;
        height: 28px;
    }

    .configuration-list {
        list-style: none;
        padding: 0px;
        margin-bottom: 20px;
        margin-top: 20px;
    }

    .btn {
        height: 28px;
        line-height: 28px;
        margin: 0px;
        padding-top: 0px;
    }

    .configruation-span {
        font-weight: bold;
    }

    .configuration-title {
        display: inline-flex;
        margin-top: 40px;
    }

    .configuration-title p {
        height: 28px;
        line-height: 28px;
        margin-right: 10px;
        font-size: 20px;
    }

    .configuration-wrapper {
        margin-bottom: 50px;
    }
</style>
